
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import IconButton from "@/components/UI/IconButton.vue";
import PanelHeader from "@/components/Reusable/Util/PanelHeader.vue";
import { MediaInputValue, MediaOptions } from "@/types/media";
import WPMediaInput from "@/components/Reusable/CustomInputs/MediaInput/WPMediaInput.vue";
import { documentStore, singularityStore, uiStore } from "@/store/store";
import { findNode } from "@/lib/tree/tree";
import lodash from "lodash";
import { UnsplashImage } from "@/lib/ai/types";
import UnsplashImageBrowser from "@/components/Singularity/UnsplashImageBrowser/UnsplashImageBrowser.vue";
import { convertUnsplashImageToMediaInputValue } from "@/futurelayer/images/util";

@Component({
  components: {
    Dropdown,
    IconButton,
    PanelHeader,
    WPMediaInput,
    UnsplashImageBrowser
  }
})
export default class BackgroundImageEditor extends Vue {
  get sectionId() {
    return singularityStore.backgroundImageEditorPanelState?.sectionId;
  }

  get mediaInputValue() {
    if (!this.sectionId) return null;

    const node = findNode(documentStore.document.tree, this.sectionId);

    if (!node) return null;

    const result = lodash.get(node.data.properties, PATH_TO_BACKGROUND_IMAGE_INPUT);

    if (!result) return null;

    return result;
  }

  updateMediaInputValue(value: MediaInputValue) {
    if (!this.sectionId) return;

    documentStore.unthrottledPropertyChanged({
      elementId: this.sectionId,
      path: PATH_TO_BACKGROUND_IMAGE_INPUT,
      value: value,
      meta: {
        snapshotLabel: "Background Image Editor Media Input Update"
      }
    });
  }

  get mediaInputOptions(): MediaOptions {
    return {
      acceptedFileTypes: ["image"]
    };
  }

  backToPageStructurePanel() {
    singularityStore.setSingularityLeftPanel("page_structure");
  }

  handleImageSelected(image: UnsplashImage) {
    const mediaInputValue = convertUnsplashImageToMediaInputValue(image);
    this.updateMediaInputValue(mediaInputValue);
  }

  close() {
    alert("close");
  }

  get uiStoreActiveElementId() {
    return uiStore.activeElementId;
  }

  @Watch("uiStoreActiveElementId")
  closePanelIfElementIdChanges() {
    if (this.sectionId !== this.uiStoreActiveElementId) {
      singularityStore.setBackgroundImageEditorPanelState(null);
    }
  }

}

const PATH_TO_BACKGROUND_IMAGE_INPUT = 'design.background.image';
